import styled from 'styled-components'
import { getScollerCSS } from '@components/Scroller/style'

export const Actions = styled.div`
  ${({ theme }) => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 17px;

    [data-key='max-checkbox__label'] {
      margin-left: 3px;
      font-size: ${theme.fontSize.xxs};
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: 0.49px;
    }

    .select {
      display: flex;
      align-items: center;
      color: ${theme.palette.charcoal};
      font-size: ${theme.fontSize.xxs};
      font-weight: ${theme.fontWeight.bold};
      font-stretch: normal;
      font-style: normal;
      line-height: 1.14;
      letter-spacing: 0.49px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      
      @media (min-width: ${theme.breakpoints.sm}) {
        flex-direction: row;
        align-items: center;

        label {
          margin-left: ${theme.space.xs};
        }
      }
    }
  `}
`

export const InstructorCards = styled.div`
  ${getScollerCSS({
    border: '1px solid #cacaca',
    bgColor: '#cacaca',
  })}

  height: 316px;
  overflow-y: scroll;

  ${({ theme }) => `
    display: flex;
    flex-wrap: wrap;
    padding-right: 0px;
    align-content: flex-start;

    @media (max-width: ${theme.breakpoints.sm}) {
      padding-right: 10px;
    }
  `}
`

export const InstructorCard = styled.div`
  ${({ theme }) => `
    width: 100%;
    margin-right: 0px;

    @media (min-width: ${theme.breakpoints.sm}) {
      max-width: calc(50% - 10px);
      margin-right: 10px;
    }

    @media (min-width: ${theme.breakpoints.md}) {
      max-width: calc(33.333333333% - 10px);
      margin-right: 10px;
    }

    @media (min-width: ${theme.breakpoints.lg}) {
      max-width: calc(33.333333333% - 10px);
      margin-right: 10px;
    }

    @media (min-width: ${theme.breakpoints.xl}) {
      max-width: calc(33.333333333% - 10px);
      margin-right: 10px;
    }
  `}
`

export const ErorrWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;

    h3 {
      font-size: ${theme.fontSize.sm};
      font-weight: ${theme.fontWeight.bold};
      text-align: center;
      line-height: 1.56;
    }
  `}
`
